import {Settings} from '../../ng-data-table/base/settings';

export class CdtSettings extends Settings {
  crud?: boolean;
  initLoad?: boolean = true;
  globalFilter?: boolean;
  clickRows?: boolean;
  singleRowView?: boolean = true;
  zIndexModal?: number;
  exportAction?: boolean;
  exportKMLAction?: boolean;
  columnToggleAction?: boolean;
  clearAllFiltersAction?: boolean;
  clearAllFiltersIcon?: boolean = true;
  unshiftExpandIcon?: boolean = false;//To toggle expanding(popup details view screen) icon column - IMP
  unPopDelIcon?: boolean = false;//To toggle Del icon column  at the end of tabe - IMP

  constructor(init: Partial<CdtSettings>) {
    super(init);
    Object.assign(this, init);
  }

}
